module.exports = __webpack_public_path__ + "assets/img/creation_icon_a.47aa0b21.png";